import Navbar from '../Navbar';
import { useState } from 'react';
import Carousel from "components/Carousel";
import Badge from 'components/Carousel/Badge';
import MainFooter from 'components/MainFooter';
import { MobileShow, MobileSection } from './styled';
import { sidebarRoutes } from 'constants/sidebar';
import { useActivity } from 'hooks/useBusiness.js';
import { advertsForWebPlacement } from 'utils/advertFilters';

const Layout = ({ children }) => {

  const { state } = useActivity()
  const advert = advertsForWebPlacement(state?.adverts, 'bottom')
  return (
    <>
      <MobileSection>
        <Navbar />
        <MobileShow>{children}</MobileShow>
      </MobileSection>

      {advert?.length > 0 ? <Carousel position="bottom" /> : <Badge />}
      <MainFooter />
    </>
  )
};

const WithLayout = (Component) => {
  return (props) => {
    return (
      <Layout>
        <Component {...props} />
      </Layout>
    )
  }
}

export default WithLayout;
